import React from 'react'
import { Button, Container, Dropdown, Header, Icon, List } from 'semantic-ui-react'

import _ from 'underscore'
import moment from 'moment'

import $ from 'jquery'
import fetch from 'isomorphic-fetch'

import Env from './Env'

const ROOT_URL = Env.ROOT_URL

const authenticated = () => {
  return (
    /localhost/.test(document.location) ||
    /validator.(arcticdataservices|mikerisse|echemdata).com/.test(document.location) ||
    /validator.chemdata.net/.test(document.location)
  )
}

// Creates the valid value CSV for user download

function download_csv(data) {
  var csv = 'Field,ValidValue,Name\n'
  data.forEach(function (row) {
    csv += row['field'] + ',' + row['vvl'] + ',' + row['name']
    csv += '\n'
  })
  console.log(csv)
  var hiddenElement = document.createElement('a')
  hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
  hiddenElement.target = '_blank'
  hiddenElement.download = 'validvalues.csv'
  hiddenElement.click()
}

// based off of https://stackoverflow.com/questions/30522868/get-line-number-of-xml-node-in-js
const xmlNodeToOriginalLineNumber = function (element, xmlRootNode, sContent) {
  var sTagName = element.tagName
  var aNodeListByTag = xmlRootNode.getElementsByTagName(sTagName)
  var iMaxIndex = 0
  for (var j = 0; j < aNodeListByTag.length; j++) {
    if (aNodeListByTag.item(j) === element) {
      iMaxIndex = j
      break
    }
  }
  var regex = new RegExp('<' + sTagName + '\\W', 'g')
  var offset = 0
  for (var i = 0; i <= iMaxIndex; i++) {
    offset = regex.exec(sContent).index
  }
  var line = 0
  for (var i2 = 0; i2 < sContent.substring(0, offset).length; i2++) {
    if (sContent[i2] === '\n') {
      line++
    }
  }
  return line + 1
}

export default class Report extends React.Component {
  constructor(props) {
    super(props)
    this.pollImport = this.pollImport.bind(this)
    this.state = { events: [] }
  }

  // Fetches events and related info for select event to import to

  componentDidMount() {
    fetch(`${ROOT_URL}/events.json`, { mode: 'cors', credentials: 'include' })
      .then(response => response.json())
      .then(result => {
        this.setState({ events: result })
      })
  }

  projects() {
    console.log(this.state.events)
    console.log(this.state.clientId)
    const projects = _.unique(
      this.state.events
        .filter(e => e.client_id === this.state.clientId)
        .map(e => {
          return { key: e.project_id, text: e.project_name, value: e.project_id }
        }),
      p => p.key
    )
    console.log('returning projects', projects)
    return projects
  }

  clients() {
    return _.unique(
      this.state.events.map(e => {
        return { key: e.client_id, text: e.client_name, value: e.client_id }
      }),
      c => c.key
    )
  }

  events() {
    return this.state.events
      .filter(e => e.project_id === parseInt(this.state.projectId))
      .map(e => {
        return { key: e.id, text: e.name, value: e.id }
      })
  }

  pollImport(id) {
    const interval = setInterval(() => {
      fetch(`${ROOT_URL}/imports/${id}.json`, { credentials: 'include' })
        .then(response => response.json())
        .then(data => {
          this.setState({
            importStatus: data.status,
            importReport: data.report
          })
          if (data.status === 'COMPLETE' || data.status === 'FAILED') {
            clearInterval(interval)
          }
        })
    }, 1 * 1000)

    //poll import and set state appropriately
  }

  errorList(errors, color, title) {
    let index = 0

    return (
      <React.Fragment>
        <Header dividing>
          <Icon name="warning sign" color={color} /> {title}
        </Header>

        <List>
          {_.chain(errors)
            .groupBy(error => `${error.message}${error.element.tagName}`)
            .map((errors, group) => {
              return (
                <List.Item key={group}>
                  <List.Icon name="warning sign" color={color} />
                  <List.Content>
                    <List.Header>{errors[0].message}</List.Header>
                    <List.Description>
                      (at parent node {errors[0].element.tagName}: Line{' '}
                      {index++ < 20
                        ? xmlNodeToOriginalLineNumber(
                            errors[0].element,
                            this.props.xmlDoc,
                            this.props.rawXml
                          )
                        : '???'}
                      ){errors.length > 1 && ` [and ${errors.length - 1} similar...]`}
                    </List.Description>
                  </List.Content>
                </List.Item>
              )
            })
            .value()}
        </List>
      </React.Fragment>
    )
  }

  render() {
    if (!this.props.errors) return <div>loading</div>
    return (
      <Container style={{ paddingTop: 50, paddingBottom: 50 }}>
        <Header>
          {this.props.seddInfo.labName} / {this.props.seddInfo.labDataPackageId}
          <Header.Subheader>{this.props.seddInfo.eddImplementationId}</Header.Subheader>
        </Header>

        <div>{this.props.seddInfo.clientName}</div>
        <div>{this.props.seddInfo.projectName}</div>
        <div>
          Reported {moment(this.props.seddInfo.labReportedDate).format('MMMM Do YYYY, h:mm a')}
        </div>
        <div>
          Validated {moment(this.props.seddInfo.dateValidated).format('MMMM Do YYYY, h:mm a')}
        </div>

        {this.props.errors.length === 0 && this.state.events.length > 0 && (
          <React.Fragment>
            <Header>Import meta-information</Header>

            <Dropdown
              style={{ marginRight: 30 }}
              search
              placeholder="Select client..."
              options={this.clients()}
              onChange={(e, data) => {
                console.log('VALUE', data.value)
                this.setState({ clientId: parseInt(data.value) })
              }}
            />
            <Dropdown
              style={{ marginRight: 30 }}
              disabled={!this.state.clientId}
              search
              placeholder="Select project..."
              options={this.projects()}
              onChange={(e, data) => {
                this.setState({ projectId: parseInt(data.value) })
              }}
            />
            <Dropdown
              style={{ marginRight: 30 }}
              disabled={!this.state.projectId}
              search
              placeholder="Select event..."
              options={this.events()}
              onChange={(e, data) => {
                this.setState({ eventId: parseInt(data.value) })
              }}
            />
          </React.Fragment>
        )}

        {this.props.errors.length === 0 && this.props.warnings.length === 0 && (
          <h3>SEDD validated with no errors or warnings</h3>
        )}

        {this.props.errors.length !== 0 && this.errorList(this.props.errors, 'red', 'Errors')}

        {this.props.errors.length !== 0 &&         
        <a href="#" onClick={() => download_csv(this.props.validFields)}>
          Download Valid Values CSV
        </a>} 

        {this.props.warnings.length !== 0 &&
          this.errorList(this.props.warnings, 'orange', 'Warnings')}

        {this.state.failure && (
          <div style={{ color: 'red' }}>Upload Failed (try refreshing page and trying again)</div>
        )}  

        {authenticated() &&
          this.state.importStatus !== 'IMPORTING' &&
          this.state.importStatus !== 'COMPLETE' &&
          !this.state.imported &&
          this.props.errors.length === 0 && (
            <Button
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.setState({ importStatus: 'IMPORTING' })
                this.props.uploadXml(this.state.eventId, (error, result) => {
                  if (error) {
                    this.setState({ imported: true, importing: false, failure: true })
                  } else {
                    console.log('RECEIVED RESULT', result)
                    this.setState({ imported: false, importing: true, failure: false })
                    this.pollImport(result.id)
                  }
                })
              }}
            >
              Upload
            </Button>
          )}

        {authenticated() && this.state.importStatus === 'COMPLETE' && (
          <Button
            onClick={() => {
              document.location = '/'
            }}
          >
            Upload and validate another
          </Button>
        )}

        {authenticated() && this.props.errors.length > 0 && (
          <strong>*Sedd Contains Errors, Cannot Import*</strong>
        )}

        <div>Status: {this.state.importStatus} </div>
        <div>Report: {this.state.importReport}</div>
      </Container>
    )
  }
}
